import type { StyleRule } from '@archipro-design/aria';
import { checkboxClassName } from '@archipro-design/aria';
import { drawerSlotClassNames } from '@archipro-design/aria';
import { inputClassName } from '@archipro-design/aria';
import { textInputSlotClassNames } from '@archipro-design/aria';
import { inputSlotClassNames } from '@archipro-design/aria';
import { textInputClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    pxArrayToRem,
    labelClassName,
    captionClassName,
    filterContentLayoutSlotClassNames,
} from '@archipro-design/aria';

import { buttonClassName } from '@archipro-design/aria';
import { dropdownSlotClassNames } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import {
    accordionSlotClassNames,
    buttonContentClassName,
} from '@fluentui/react-northstar';

export const FilterDialogGrid: StyleRule = ({ theme }) => ({
    gridGap: pxToRem(48),
    display: 'block',
    [`& .${labelClassName}`]: {
        color: theme.siteVariables.colors.charcoal['250'],
    },
});
export const CategoryWrapper: StyleRule = () => ({
    margin: pxArrayToRem([31, 0, 0, 0]),
});

export const CategoryHeading: StyleRule = () => ({
    margin: pxArrayToRem([0, 0, 22]),
    letterSpacing: '-0.04em',
});

export const PublishedHeading: StyleRule = () => ({
    margin: pxArrayToRem([0, 0, 22]),
});

export const FilterDropdownStyle = {
    marginBottom: pxToRem(2),
    [`& .${textInputSlotClassNames.primaryContent}`]: {
        [`& .${inputClassName}`]: {
            minHeight: 'unset',
            letterSpacing: 0,
        },
        [`& .${dropdownSlotClassNames.container}`]: {
            border: 'none',
        },
        [`& .${inputSlotClassNames.icon}`]: {
            minHeight: 'unset',
            height: pxToRem(36),
            marginTop: pxToRem(4),
            marginBottom: pxToRem(4),
        },
        [`& .${dropdownSlotClassNames.selectedItems}`]: {
            height: pxToRem(47),
        },
        [`& .${dropdownSlotClassNames.searchInput}`]: {
            padding: pxToRem(8),
            '& .ui-dropdown__items-list': {
                height: 0,
            },

            [`& input`]: {
                fontSize: pxToRem(18),
                letterSpacing: 0,
            },
        },
    },

    [`& .${inputSlotClassNames.icon}`]: {
        [`& .${svgIconClassName}`]: {
            height: pxToRem(24),
            marginTop: pxToRem(8),
            marginBottom: pxToRem(2),
        },
    },
};

export const DialogContentWrapper: StyleRule = ({ theme }) => ({
    '& *': {
        '-webkit-tap-highlight-color': 'transparent',
    },
    [`& .${captionClassName}`]: {
        color: theme.siteVariables.colors.charcoal['250'],
    },
    [`& .${filterContentLayoutSlotClassNames.headerAction}`]: {
        [`& .${buttonClassName}:hover`]: {
            textDecoration: 'none',
        },
        [`& .${labelClassName}`]: {
            color: theme.siteVariables.colors.charcoal['250'],
        },
    },
    [`& .${filterContentLayoutSlotClassNames.closeBtn}`]: {
        [`& .${svgIconClassName}`]: {
            '& svg': {
                fill: theme.siteVariables.colors.charcoal['250'],
            },
        },
    },
    [`& .${filterContentLayoutSlotClassNames.footer}`]: {
        [`& .${labelClassName}`]: {
            textTransform: 'uppercase',
        },
    },
    [`& .${filterContentLayoutSlotClassNames.content}`]: {
        display: 'block',
    },
});

export const ApplyButton: StyleRule = ({ theme }) => {
    return {
        [`& .${labelClassName}`]: {
            color: `${theme.siteVariables.colors.white['100']} !important`,
        },
    };
};

export const FilterDrawer: StyleRule = ({ theme }) => ({
    ':focus-within': {
        [`& .${textInputClassName}`]: {
            [`& .${dropdownSlotClassNames.triggerButton}`]: {
                backgroundColor: 'transparent',
            },
        },
    },
    height: '100%',
    [`& .${dropdownSlotClassNames.selectedItems}`]: {
        overflow: 'hidden',
    },

    [`& .${drawerSlotClassNames.content} .filterContainer`]: {
        height: '100%',
        backgroundColor: theme.siteVariables.colors.white['100A'],
        width: pxToRem(498),

        [`& .${captionClassName}`]: {
            color: theme.siteVariables.colors.charcoal['000'],
        },

        [`& .${accordionSlotClassNames.title}`]: {
            color: theme.siteVariables.colors.charcoal['000'],
        },
        [`& .${labelClassName}`]: {
            color: theme.siteVariables.colors.charcoal['000'],
        },

        [`& > div`]: {
            paddingLeft: pxToRem(50),
            paddingRight: pxToRem(50),
            width: 'auto',
        },

        [`& .${checkboxClassName}`]: {
            [`& .${labelClassName}`]: {
                fontSize: theme.siteVariables.fontSizes['label02'],
            },
        },
    },
});

export const TextSelectorClearIcon = {
    [`& .${dropdownSlotClassNames.clearIndicator}`]: {
        right: pxToRem(48),
    },
};

export const DropdownDrawer: StyleRule = ({ theme }) => ({
    width: '100%',

    [`& .${dropdownSlotClassNames.selectedItems}`]: {
        width: '100%',
    },

    [`& .${dropdownSlotClassNames.triggerButton}`]: {
        paddingLeft: 0,
        paddingRight: 0,
        fontSize: pxToRem(24),
        lineHeight: '110%',
        fontWeight: theme.siteVariables.fontWeightLight,
        letterSpacing: pxToRem(1.15),
        wordSpacing: pxToRem(1),
    },

    [`& .${buttonContentClassName}`]: {
        width: '100%',
    },
});

export const SelectedOption: StyleRule = () => ({
    float: 'left',
});

export const DropdownIcons: StyleRule = () => ({
    float: 'right',
});

export const TriggerButton: StyleRule = () => ({
    width: '100%',
    [`& .${buttonContentClassName} .${dropdownSlotClassNames.selectedItems}`]: {
        width: 'unset',
    },
});

export const OptionItem: StyleRule = () => ({
    display: 'block',
    [`& .${svgIconClassName}`]: {
        float: 'right',
    },
});

export const FilterMonth: StyleRule<{ month: number | null }> = ({
    theme,
    month,
}) => ({
    ...FilterDropdownStyle,
    ...(month === null
        ? {
              [`& .${dropdownSlotClassNames.clearIndicator}`]: {
                  display: 'none',
              },
          }
        : {
              [`& .${inputSlotClassNames.input}`]: {
                  [`& .${dropdownSlotClassNames.triggerButton}`]: {
                      color: theme.siteVariables.colors.charcoal['250'],
                  },
              },
          }),
});

export const FilterYear: StyleRule<{ year: number | null }> = ({
    theme,
    year,
}) => ({
    ...FilterDropdownStyle,
    ...(year !== null && {
        [`& .${inputSlotClassNames.input}`]: {
            [`& .${dropdownSlotClassNames.triggerButton}`]: {
                color: theme.siteVariables.colors.charcoal['250'],
            },
        },
    }),
});

export const PublishedLabel: StyleRule = () => ({
    fontSize: pxToRem(30),
    marginTop: pxToRem(5),
    marginBottom: pxToRem(35),
    letterSpacing: 0,
});
